import { FullProduct, LocalStorageProduct } from "ts/api/product";
import Filter from "ts/filter";
import { IProductCategory } from "@evennt-tech/api-v2-core";

export type ProductsFilters = {
  categoryFilter?: Filter;
  coloursFilter?: Filter;
  supplierFilter?: Filter;
  tagsFilter?: Filter;
};

export const getProductsTotalQuantity = (
  productsItems: LocalStorageProduct[]
) =>
  productsItems.reduce((acc, cur) => {
    if (cur.extras?.length) {
      const extrasQuantity = cur.extras.reduce(
        (prev, extraProduct) => prev + extraProduct.quantity,
        0
      );
      return acc + cur.cartQuantity + extrasQuantity;
    }
    return acc + cur.cartQuantity;
  }, 0);

export type OrderedProductsByCategoryType = {
  [key: string]: string[];
};

export const getCategoriesForSupplierPreview = ({
  supplierCompanyId,
  categories,
  isSupplierPreviewMode,
  filteredProducts,
}: {
  supplierCompanyId?: string;
  categories: IProductCategory[];
  isSupplierPreviewMode: boolean;
  filteredProducts: FullProduct[];
}) => {
  if (!isSupplierPreviewMode || !supplierCompanyId) {
    return categories;
  }

  return categories.filter((category) => {
    const supplierProductsInCategory = filteredProducts.some(
      (product) =>
        product.owner.id === supplierCompanyId &&
        product.categories.some((cat) => cat.mainCategoryId === category.id)
    );
    return supplierProductsInCategory;
  });
};

export const findFilterByFieldPath = (
  filters: (Filter | undefined)[],
  fieldPath: string
) => {
  return filters.find((filter) => filter?.fieldPath === fieldPath);
};

export const SHOP_SCROLL_HEADER_OFFSET = 140;

export const scrollToShopSection = (
  element: Element,
  behavior: ScrollBehavior = "smooth"
): void => {
  const { top } = element.getBoundingClientRect();

  window.scrollTo({
    top: top + window.scrollY - SHOP_SCROLL_HEADER_OFFSET,
    behavior,
  });
};
